import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://www.multitrade-construction.com';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_e72d340d-3899-4876-891e-4e00170d4616/artifacts/257c2bwr_Screenshot_20260324_012710_Gallery.jpg';

// Per-page SEO metadata. Title is set via document.title (useEffect) to avoid the
// react-helmet-async "<title> child must be a string" pitfall; Helmet handles the
// meta/link/canonical/OG tags which have no such constraint.
export default function SEO({ title, description, path = '/', image = DEFAULT_IMAGE, jsonLd }) {
  const url = `${SITE}${path}`;
  const t = String(title || 'Dviso Construction');
  const d = String(description || '');

  useEffect(() => { document.title = t; }, [t]);

  useEffect(() => {
    if (!jsonLd) return undefined;
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute('data-seo-jsonld', path);
    el.text = JSON.stringify(jsonLd);
    document.head.appendChild(el);
    return () => { try { document.head.removeChild(el); } catch (e) { /* noop */ } };
  }, [jsonLd, path]);

  return (
    <Helmet>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
